// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_updateTeamMarketingProfileLogo(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["TeamMarketingProfileLogoUpdated"]);
}

var variablesConverter = {"teamLogoInput":{},"updateTeamMarketingProfileLogoInput":{"logo":{"r":"teamLogoInput"}},"__root":{"input":{"r":"updateTeamMarketingProfileLogoInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"updateTeamMarketingProfileLogo_TeamMarketingProfileLogoUpdated_marketingProfile":{"f":""},"updateTeamMarketingProfileLogo":{"u":"response_updateTeamMarketingProfileLogo"}}};

var wrapResponseConverterMap = {
  response_updateTeamMarketingProfileLogo: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"updateTeamMarketingProfileLogo_TeamMarketingProfileLogoUpdated_marketingProfile":{"f":""},"updateTeamMarketingProfileLogo":{"u":"response_updateTeamMarketingProfileLogo"}}};

var responseConverterMap = {
  response_updateTeamMarketingProfileLogo: unwrap_response_updateTeamMarketingProfileLogo
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function imageContentType_decode($$enum) {
  if ($$enum === "PNG" || $$enum === "JPEG" || $$enum === "GIF" || $$enum === "WEBP") {
    return $$enum;
  }
  
}

function imageContentType_fromString(str) {
  return imageContentType_decode(str);
}

var Utils = {
  imageContentType_decode: imageContentType_decode,
  imageContentType_fromString: imageContentType_fromString
};

var providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamMarketingProfileLogoForm_UpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateTeamMarketingProfileLogo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TeamMarketingProfileLogoForm_teamMarketingProfile"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "TeamMarketingProfileLogoUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "TeamMarketingProfileLogoForm_UpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateTeamMarketingProfileLogo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfilePhoto",
                    "kind": "LinkedField",
                    "name": "logo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "ratio",
                            "variableName": "__relay_internal__pv__DevicePixelRatio"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "TeamMarketingProfileLogoUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "361688f8ff1d565c890fe7f1e6290be8",
    "id": null,
    "metadata": {},
    "name": "TeamMarketingProfileLogoForm_UpdateMutation",
    "operationKind": "mutation",
    "text": "mutation TeamMarketingProfileLogoForm_UpdateMutation(\n  $input: UpdateTeamMarketingProfileLogoInput!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  updateTeamMarketingProfileLogo(input: $input) {\n    __typename\n    ... on TeamMarketingProfileLogoUpdated {\n      marketingProfile {\n        ...TeamMarketingProfileLogoForm_teamMarketingProfile\n        nodeId\n      }\n    }\n  }\n}\n\nfragment TeamMarketingProfileLogoForm_teamMarketingProfile on TeamMarketingProfile {\n  logo {\n    url(ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

var node = makeNode(providedVariablesDefinition);

var wrap_response_updateTeamMarketingProfileLogo = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateTeamMarketingProfileLogo = unwrap_response_updateTeamMarketingProfileLogo;
exports.wrap_response_updateTeamMarketingProfileLogo = wrap_response_updateTeamMarketingProfileLogo;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
/* node Not a pure module */
